import { AnimatedSkeletonBlock } from "@redotech/arbiter/skeleton";
import { lazy, memo, type ReactNode, Suspense } from "react";
import { HOME_JUMP_ONLY, HOME_PAGES } from "../sources/home-sources";
import type { HomeRecordType } from "../sources/record-home-source";
import { RecordHomeErrorBoundary } from "./record-home-error-boundary";
import { useRecordHomeExperience } from "./use-record-home-experience";

const LazyRecordHomePage = lazy(() =>
  import("../record-home-page").then((module) => ({
    default: module.RecordHomePage,
  })),
);

/** The only place that chooses between a type's table and its home page. */
export const RecordHomeExperienceGate = memo(function RecordHomeExperienceGate({
  type,
  legacy,
}: {
  type: HomeRecordType;
  legacy: ReactNode;
}) {
  const { useNewUi } = useRecordHomeExperience(type);
  const sources = HOME_PAGES[type];
  if (!useNewUi || !sources) {
    return legacy;
  }
  return (
    <RecordHomeErrorBoundary fallback={legacy}>
      <Suspense fallback={<AnimatedSkeletonBlock height="100%" width="100%" />}>
        <LazyRecordHomePage jumpOnly={HOME_JUMP_ONLY[type]} sources={sources} />
      </Suspense>
    </RecordHomeErrorBoundary>
  );
});
